export enum PaymentDataSourceUID {
    COMPANY_TYPE = "company_type",
}